<div class="portal-container">
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="portal-header">
    <h1 class="portal-title">Klinikportal</h1>
    <button class="save-btn"
            [class.has-changes]="hasUnsavedChanges()"
            (click)="saveAll()"
            [disabled]="isLoading || isSaving">
      @if (isSaving) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        Speichern
      }
    </button>
  </div>

  @if (clinic) {
    <div class="portal-content">
      <div class="editor-column">
        <app-block-editor
          [blocks]="blocks"
          [blockTypes]="blockTypes"
          [clinic]="clinic!"
          (blocksChange)="blocks = $event"
          (clinicChange)="clinic = $event">
        </app-block-editor>
      </div>
      <div class="preview-column">
        <app-preview [clinic]="clinic" [blocks]="blocks"></app-preview>
      </div>
    </div>
  }
</div>

<app-bottom-bar></app-bottom-bar>
